import qs from 'qs';
import { PHONE_ANALYTIC_ATTRIBUTE } from '../../constants/analytics';
import './ContactsPhoneButton.scss';

const attachListenerShowPhone = (node = document) => {
  const buttons = node.querySelectorAll('[data-phone="button"]');
  if (buttons.length === 0) return;
  [].forEach.call(buttons, (button) => {
    const text = button.querySelector('[data-button="content"]');
    const phone = button.getAttribute(PHONE_ANALYTIC_ATTRIBUTE);
    const showPhone = (event) => {
      event.preventDefault();
      if (text) text.textContent = phone.slice(phone.indexOf('|') + 1);
      if (button.dataset.short) {
        button.classList.add('-hiddenIcon');
      }
      button.removeEventListener('click', showPhone);
    };

    button.addEventListener('click', showPhone);
  });
};

const initPhoneAnalytics = () => {
  const phoneNodes = document.querySelectorAll(`[data-save-phone-click]`);
  [].forEach.call(phoneNodes, (node) => {
    node.addEventListener('click', () => {
      const params = node.getAttribute(PHONE_ANALYTIC_ATTRIBUTE).split('|');
      const searchParams = qs.parse(window.location.search.split('?')[1]);
      const xhr = new XMLHttpRequest();
      xhr.open('POST', `${window.cabinetApiEndpoint}/save-show-phone-click`, true);
      xhr.setRequestHeader('Content-type', 'application/json');
      xhr.withCredentials = true;
      xhr.send(
        JSON.stringify({
          userId: window.userId || null,
          buildingId: params[0],
          phone: params[1],
          userAgent: window.navigator.userAgent,
          page: document.location.href,
          event_category: node.dataset.eventCategory,
          gclid: searchParams.gclid,
        }),
      );
    });
  });
};

export const initPhone = (node = document) => {
  attachListenerShowPhone(node);
  initPhoneAnalytics();
};
